import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { Router } from '@angular/router';
import { startWith, map, Observable } from 'rxjs';
import { MyListingsService } from '../../services/my-listings.service';
import { LocalStorageService } from '../../services/local-storage.service';
import { HeaderComponent } from '../header/header.component';
import { ToastService, ToastType } from '../../services/toast.service';

@Component({
  selector: 'app-interior',
  templateUrl: './interior.component.html',
  styleUrls: ['./interior.component.css'],
})
export class InteriorComponent {
  @ViewChild(HeaderComponent) header: HeaderComponent;

  separatorKeysCodes: number[] = [ENTER, COMMA];
  roomCtrl = new FormControl('');
  interiorCtrl = new FormControl('');
  heatCtrl = new FormControl('');
  coolCtrl = new FormControl('');
  utilCtrl = new FormControl('');
  energyCtrl = new FormControl('');

  interiorData: {};
  filteredAppliances: Observable<string[]>;
  filteredCoolingItems: Observable<string[]>;
  filteredInteriorFeatures: Observable<string[]>;
  filteredHeatingItems: Observable<string[]>;
  filteredUtilItems: Observable<string[]>;
  filteredEnergyItems: Observable<string[]>;

  Appliances: any[] = [];
  energyGeneration: any[] = [];
  InteriorFeatures: any[] = [];
  utils: any[] = [];
  Heating: any[] = [];
  Cooling: any[] = [];

  allenergyGeneration: string[] = ["Solar", "Wind"];
  allAppliances: string[] = ["Bar Fridge", "Built-In Electric Oven", "Built-In Electric Range", "Built-In Freezer", "Built-In Gas Oven", "Built-In Gas Range", "Built-In Range", "Built-In Refrigerator", "Convection Oven", "Cooktop", "Dishwasher", "Disposal", "Double Oven", "Down Draft", "Dryer", "Electric Cooktop", "Electric Oven", "Electric Range", "Electric Water Heater", "ENERGY STAR Qualified Appliances", "ENERGY STAR Qualified Dishwasher", "ENERGY STAR Qualified Dryer", "ENERGY STAR Qualified Freezer", "ENERGY STAR Qualified Refrigerator", "ENERGY STAR Qualified Washer", "ENERGY STAR Qualified Water Heater", "Exhaust Fan", "Free-Standing Electric Oven", "Free-Standing Electric Range", "Free-Standing Freezer", "Free-Standing Gas Oven", "Free-Standing Gas Range", "Free-Standing Range", "Free-Standing Refrigerator", "Freezer", "Gas Cooktop", "Gas Oven", "Gas Range", "Gas Water Heater", "Humidifier", "Ice Maker", "Indoor Grill", "Induction Cooktop", "Instant Hot Water", "Microwave", "None", "Other", "Oven", "Plumbed For Ice Maker", "Portable Dishwasher", "Propane Cooktop", "Range", "Range Hood", "Refrigerator", "Self Cleaning Oven", "Solar Hot Water", "Stainless Steel Appliance(s)", "Tankless Water Heater", "Trash Compactor", "Vented Exhaust Fan", "Warming Drawer", "Washer", "Washer/Dryer", "Washer/Dryer Stacked", "Water Heater", "Water Purifier", "Water Purifier Owned", "Water Purifier Rented", "Water Softener", "Water Softener Owned", "Water Softener Rented", "Wine Cooler", "Wine Refrigerator"];
  allUtils: string[] = ["Cable", "Electricity", "Natural Gas", "Phone", "Propane", "Sewer", "Water",];
  // allCooling: string[] = ["Exhaust", "Fan", "Gas", "None", "Other"];
  allCooling: string[] = ["Attic Fan", "Ceiling Fan(s)", "Central Air", "Dual", "Ductless", "Electric", "ENERGY STAR Qualified Equipment", "Evaporative Cooling", "Exhaust", "Fan", "Gas", "None", "Other", "Roof Turbine(s)", "Separate Meters", "Wall/Window Unit(s)", "Wall Unit(s)", "Whole House Fan", "Window Unit(s)", "Zoned"];
  // allHeating: string[] = ["Ductless", "Electric", "ENERGY STAR Qualified Equipment", "Exhaust Fan", "Geothermal", "Heat Pump", "Hot Water", "Humidity Control", "None", "Other", "Pellet Stove", "Propane", "Separate Meters,Solar", "Varies by Unit", "Wood", "Zoned"]
  allHeating: string[] = ["Active Solar", "Baseboard", "Ceiling", "Central", "Coal", "Coal Stove", "Ductless", "Electric", "ENERGY STAR/ACCA RSI Qualified Installation", "ENERGY STAR Qualified Equipment", "Exhaust Fan", "Fireplace(s)", "Fireplace Insert", "FloorFurnace", "Forced Air", "Geothermal", "Gravity", "Heat Pump", "Hot Water", "Humidity Control", "Kerosene", "Natural Gas", "None", "Oil", "Other", "Passive Solar", "Pellet Stove", "Propane", "Propane Stove", "Radiant", "Radiant Ceiling", "Radiant Floor", "Separate Meters", "Solar", "Space Heater", "Steam", "Varies by Unit", "Wall Furnace", "Wood", "Wood Stove", "Zoned"];
  // allInteriorFeatures: string[] = ['Bar', 'Ceiling Fan(s)', 'Other', 'Pantry', 'See Remarks', 'Storage'];
  allInteriorFeatures: string[] = ['Bar', 'Beamed Ceilings', 'Bidet', 'Bookcases', 'Breakfast Bar', 'Built-in Features', 'Cathedral Ceiling(s)', 'Cedar Closet(s)', 'Ceiling Fan(s)', 'Central Vacuum', 'Chandelier', 'Coffered Ceiling(s)', 'Crown Molding', 'Double Vanity', 'Dry Bar', 'Dumbwaiter', 'Eat-in Kitchen', 'Elevator', 'Entrance Foyer', 'Granite Counters', 'High Ceilings', 'High Speed Internet', 'His and Hers Closets', 'In-Law Floorplan', 'Kitchen Island', 'Laminate Counters', 'Low Flow Plumbing Fixtures', 'Master Downstairs', 'Natural Woodwork', 'Open Floorplan', 'Other', 'Pantry', 'Recessed Lighting', 'Smart Home', 'Smart Thermostat', 'Soaking Tub', 'Solar Tube(s)', 'Sound System', 'Stone Counters', 'Storage', 'Tile Counters', 'Track Lighting', 'Tray Ceiling(s)', 'Vaulted Ceiling(s)', 'Walk-In Closet(s)', 'WaterSense Fixture(s)', 'Wet Bar', 'Wired for Data', 'Wired for Sound'];

  @ViewChild('applianceInput') applianceInput: ElementRef<HTMLInputElement>;
  @ViewChild('interiorFeatureInput') interiorFeatureInput: ElementRef<HTMLInputElement>;
  @ViewChild('heatingInput') heatingInput: ElementRef<HTMLInputElement>;
  @ViewChild('coolingInput') coolingInput: ElementRef<HTMLInputElement>;
  @ViewChild('utilInput') utilInput: ElementRef<HTMLInputElement>;
  @ViewChild('energyInput') energyInput: ElementRef<HTMLInputElement>;

  FireplacesTotal: number = null;
  historyState: any;
  myListingId: string;
  isLoader = false;

  constructor(
    private router: Router,
    public localStorageService: LocalStorageService,
    public myListingsService: MyListingsService,
    public toastService: ToastService,
  ) {
    this.filteredAppliances = this.roomCtrl.valueChanges.pipe(
      startWith(null),
      map((Appliances: string | null) =>
        Appliances ? this._filter(Appliances) : this.allAppliances.slice()
      )
    );

    this.filteredInteriorFeatures = this.interiorCtrl.valueChanges.pipe(
      startWith(null),
      map((features: string | null) =>
        features ? this._interiorFeaturesfilter(features) : this.allInteriorFeatures.slice()
      )
    );

    this.filteredHeatingItems = this.heatCtrl.valueChanges.pipe(
      startWith(null),
      map((features: string | null) =>
        features ? this._heatingItemsfilter(features) : this.allHeating.slice()
      )
    );
    this.filteredCoolingItems = this.coolCtrl.valueChanges.pipe(
      startWith(null),
      map((features: string | null) =>
        features ? this._coolingItemsfilter(features) : this.allCooling.slice()
      )
    );

    this.filteredUtilItems = this.utilCtrl.valueChanges.pipe(
      startWith(null),
      map((features: string | null) =>
        features ? this._utilItemfilter(features) : this.allUtils.slice()
      )
    );

    this.filteredEnergyItems = this.energyCtrl.valueChanges.pipe(
      startWith(null),
      map((features: string | null) =>
        features ? this._Energyfilter(features) : this.allenergyGeneration.slice()
      )
    );

  }

  add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    if (value) {
      this.Appliances.push(value);
    }
    event.chipInput!.clear();
    this.roomCtrl.setValue(null);
  }

  remove(Appliances: string): void {
    const index = this.Appliances.indexOf(Appliances);
    if (index >= 0) {
      this.Appliances.splice(index, 1);
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    this.Appliances.push(event.option.viewValue);
    this.Appliances = this.removeDuplicates(this.Appliances);
    this.applianceInput.nativeElement.value = '';
    this.roomCtrl.setValue(null);
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.allAppliances.filter((Appliances) =>
      Appliances.toLowerCase().includes(filterValue)
    );
  }

  removeDuplicates(arr): any[] {
    return [...new Set(arr)];
  }

  addInteriorFeatures(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    if (value) {
      this.InteriorFeatures.push(value);
    }
    event.chipInput!.clear();
    this.interiorCtrl.setValue(null);
  }

  removeInteriorFeatures(features: string): void {
    const index = this.InteriorFeatures.indexOf(features);
    if (index >= 0) {
      this.InteriorFeatures.splice(index, 1);
    }
  }

  selectedInteriorFeatures(event: MatAutocompleteSelectedEvent): void {
    this.InteriorFeatures.push(event.option.viewValue);
    this.InteriorFeatures = this.removeDuplicates(this.InteriorFeatures);
    this.interiorFeatureInput.nativeElement.value = '';
    this.interiorCtrl.setValue(null);
  }

  private _interiorFeaturesfilter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.allInteriorFeatures.filter((features) =>
      features.toLowerCase().includes(filterValue)
    );
  }

  addHeatingItems(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    if (value) {
      this.Heating.push(value);
    }
    event.chipInput!.clear();
    this.heatCtrl.setValue(null);
  }
  removeHeatingItems(features: string): void {
    const index = this.Heating.indexOf(features);
    if (index >= 0) {
      this.Heating.splice(index, 1);
    }
  }
  selectedHeatingItems(event: MatAutocompleteSelectedEvent): void {
    this.Heating.push(event.option.viewValue);
    this.Heating = this.removeDuplicates(this.Heating);
    this.heatingInput.nativeElement.value = '';
    this.heatCtrl.setValue(null);
  }

  private _heatingItemsfilter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.allHeating.filter((features) =>
      features.toLowerCase().includes(filterValue)
    );
  }

  addCoolingItems(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    if (value) {
      this.Cooling.push(value);
    }
    event.chipInput!.clear();
    this.coolCtrl.setValue(null);
  }
  removeCoolingItems(features: string): void {
    const index = this.Cooling.indexOf(features);
    if (index >= 0) {
      this.Cooling.splice(index, 1);
    }
  }
  selectedCoolingItems(event: MatAutocompleteSelectedEvent): void {
    this.Cooling.push(event.option.viewValue);
    this.Cooling = this.removeDuplicates(this.Cooling);
    this.coolingInput.nativeElement.value = '';
    this.coolCtrl.setValue(null);
  }
  private _coolingItemsfilter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.allCooling.filter((features) =>
      features.toLowerCase().includes(filterValue)
    );
  }

  addEnergyItems(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    if (value) {
      this.utils.push(value);
    }
    event.chipInput!.clear();
    this.energyCtrl.setValue(null);
  }
  removeEnergyItems(features: string): void {
    const index = this.energyGeneration.indexOf(features);
    if (index >= 0) {
      this.energyGeneration.splice(index, 1);
    }
  }
  selectedEnergyItems(event: MatAutocompleteSelectedEvent): void {
    this.energyGeneration.push(event.option.viewValue);
    this.energyGeneration = this.removeDuplicates(this.energyGeneration);
    this.energyInput.nativeElement.value = '';
    this.energyCtrl.setValue(null);
  }
  private _Energyfilter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.allenergyGeneration.filter((features) =>
      features.toLowerCase().includes(filterValue)
    );
  }

  addUtilItems(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    if (value) {
      this.utils.push(value);
    }
    event.chipInput!.clear();
    this.utilCtrl.setValue(null);
  }
  removeUtilItems(features: string): void {
    const index = this.utils.indexOf(features);
    if (index >= 0) {
      this.utils.splice(index, 1);
    }
  }
  selectedUtilItems(event: MatAutocompleteSelectedEvent): void {
    this.utils.push(event.option.viewValue);
    this.utils = this.removeDuplicates(this.utils);
    this.utilInput.nativeElement.value = '';
    this.utilCtrl.setValue(null);
  }
  private _utilItemfilter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.allUtils.filter((features) =>
      features.toLowerCase().includes(filterValue)
    );
  }

  ngOnInit(): void {
    this.historyState = history.state;
    if (!this.historyState.address) {
      this.router.navigateByUrl('/my-listing');
      return;
    }
    this.myListingId = this.historyState.myListingId ? this.historyState.myListingId : this.localStorageService.get('myListingId') ? this.localStorageService.get('myListingId') : null;
    if (this.historyState && this.historyState.interiorData) {
      this.Appliances = this.historyState.interiorData.Appliances;
      this.FireplacesTotal = this.historyState.interiorData.FireplacesTotal;
      this.InteriorFeatures = this.historyState.interiorData.InteriorFeatures;
      this.Heating = this.historyState.interiorData.Heating;
      this.Cooling = this.historyState.interiorData.Cooling;
      this.utils = this.historyState.interiorData.Utilities;
      this.energyGeneration = this.historyState.interiorData.GreenEnergyGeneration;
    } else {

      if (this.historyState.listingDetails && this.historyState.listingDetails.Appliances) {
        this.Appliances = this.historyState.listingDetails.Appliances.split(',');
      } else {
        this.Appliances = [];
      }
      if (this.historyState.listingDetails && this.historyState.listingDetails.InteriorFeatures) {
        this.InteriorFeatures = this.historyState.listingDetails.InteriorFeatures.split(',');
      } else {
        this.InteriorFeatures = [];
      }
      if (this.historyState.listingDetails && this.historyState.listingDetails.Heating) {
        this.Heating = this.historyState.listingDetails.Heating.split(',');
      } else {
        this.Heating = [];
      }
      if (this.historyState.listingDetails && this.historyState.listingDetails.Cooling) {
        this.Cooling = this.historyState.listingDetails.Cooling.split(',');
      } else {
        this.Cooling = [];
      }
      if (this.historyState.listingDetails && this.historyState.listingDetails.utils) {
        this.utils = this.historyState.listingDetails.utils.split(',');
      } else {
        this.utils = [];
      }
      if (this.historyState.listingDetails && this.historyState.listingDetails.energyGeneration) {
        this.energyGeneration = this.historyState.listingDetails.energyGeneration.split(',');
      } else {
        this.energyGeneration = [];
      }

      if (this.historyState.listingDetails && this.historyState.listingDetails.FireplacesTotal) {
        if (typeof (this.historyState.listingDetails.FireplacesTotal) == 'string') {
          this.FireplacesTotal = parseInt(this.historyState.listingDetails.FireplacesTotal);
        } else {
          this.FireplacesTotal = this.historyState.listingDetails.FireplacesTotal;
        }

      } else if (this.historyState.propertyDetails && (this.historyState.propertyDetails.FireplacesTotal !== 0 || this.historyState.propertyDetails.FireplacesTotal == 0)) {

        if (typeof (this.historyState.propertyDetails.FireplacesTotal) == 'string') {
          this.FireplacesTotal = parseInt(this.historyState.propertyDetails.FireplacesTotal);
        } else {
          this.FireplacesTotal = this.historyState.propertyDetails.FireplacesTotal;
        }

      } else {
        this.FireplacesTotal = null;
      }
    }




  }

  back() {
    this.router.navigateByUrl('/basement', {
      state: this.historyState
    });
  }

  saveInteriorData(submit) {
    this.isLoader = true;
    this.interiorData = {
      Appliances: this.Appliances,
      FireplacesTotal: this.FireplacesTotal,
      InteriorFeatures: this.InteriorFeatures,
      Heating: this.Heating,
      Cooling: this.Cooling,
      Utilities: this.utils,
      GreenEnergyGeneration: this.energyGeneration
    }
    this.updateMyListings(submit);

  }

  updateMyListings(submit) {
    if (submit == null || submit == 'skip') {
      if (!this.historyState.completedIndex || this.historyState['completedIndex'] < 1.4) {
        this.interiorData["stage"] = 1.4;
      }

      if (this.historyState.stageName) {
        if (this.historyState.stageName.split(',').indexOf('Interior') <= -1) {
          this.interiorData["stageName"] = "Interior" + "," + this.historyState.stageName;
        }
      } else {
        this.interiorData["stageName"] = "Interior" + "," + "Home Details";
      }
    }

    this.interiorData["updatedDate"] = new Date();

    this.interiorData = this.filterInputJson(this.interiorData);

    this.myListingsService.UpdateListing(this.myListingId, this.interiorData).subscribe(
      {
        next: (res) => {
          if (!this.historyState.completedIndex || this.historyState['completedIndex'] < 1.4) {
            this.historyState['completedIndex'] = 1.4;
          }
          this.historyState['interiorData'] = this.interiorData;
          this.historyState.stageName = this.interiorData["stageName"];
          this.isLoader = false;

          if (submit == 'skip') {
            this.historyState['completedIndex'] = 1.7;
            this.router.navigateByUrl('/plans', {
              state: this.historyState
            });
          } else {
            this.router.navigateByUrl('/exterior', {
              state: this.historyState
            });
          }

        },
        error: (err) => {
          console.log('UpdateListing err!!!!');
          this.isLoader = false;
          console.log(err);
        }
      }
    );
  }

  skip() {
    this.historyState['completedIndex'] = 1.7;
    this.router.navigateByUrl('/plans', {
      state: this.historyState
    });
  }

  filterInputJson(obj) {
    Object.keys(obj).forEach(key => {
      if (obj[key] == null) {
        delete obj[key];
      }
    });
    return obj;
  }

}



